import React from 'react';
import {FormField as FormFieldType, FormData, FormFiles, FormErrors} from '../../../../types/ContactForm';
import {EmailWithCopyField} from './EmailWithCopyField';
import {TextInputField} from './TextInputField';
import {NumberInputField} from './NumberInputField';
import {TextareaField} from './TextareaField';
import {SelectField} from './SelectField';
import {CheckboxField} from './CheckboxField';
import {RadioField} from './RadioField';
import {AcceptanceField} from './AcceptanceField';
import {StarRatingField} from './StarRatingField';
import {FileField} from './FileField';
import {GenericField} from './GenericField';
import './FormField.scss';

interface FormFieldProps {
    field: FormFieldType;
    formData: FormData;
    files: FormFiles;
    errors: FormErrors;
    maxFileSize?: number;
    inputCssClass?: string;
    genericFieldValues?: Partial<Record<import('../../../../types/ContactForm').GenericFieldType, string>>;
    onInputChange: (name: string, value: string) => void;
    onFileChange: (name: string, file: File | File[] | null) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const FormField: React.FC<FormFieldProps> = (props) => {

    const componentMap: Record<string, React.FC<FormFieldProps>> = {
        text: TextInputField,
        number: NumberInputField,
        email: TextInputField,
        url: TextInputField,
        tel: TextInputField,
        'email-with-copy': EmailWithCopyField,
        textarea: TextareaField,
        select: SelectField,
        checkbox: CheckboxField,
        radio: RadioField,
        acceptance: AcceptanceField,
        'star-rating': StarRatingField,
        file: FileField,
        generic: GenericField,
    }

    const Component = componentMap[props.field.type];

    return (
        <Component {...props} />
    )
}; 